import { Card, Icon, Link, Stack, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useReferralCode } from "../../../components/referral/useReferralCode";

export { ReferAndEarn } from "../../../components/referral/ReferAndEarn";
export {
  buildMailtoShareHref,
  buildReferralShareMessage,
  buildSmsShareHref,
  buildWhatsAppShareHref,
} from "../../../components/referral/referralShare";

export function ReferAndEarnTeaser() {
  const { t } = useTranslation();
  const { isFlagEnabled, code } = useReferralCode();

  if (!isFlagEnabled || !code) {
    return null;
  }

  const heading = t("Know someone who needs a background check?");

  return (
    <Card
      type="large"
      border="border-base"
      testID="refer-and-earn"
      ariaLabel={heading}
      className={styles.card}
    >
      <Stack gap="space-3">
        <Stack orientation="horizontal" align="center" gap="space-2">
          <Icon name="redeem" size="space-6" color="icon-accent-tofino" />
          <Text as="h2" style="global/heading-large">
            {heading}
          </Text>
        </Stack>
        <Text style="global/body-primary">{t("Refer and earn")}</Text>
        <Link
          href="/settings/refer-and-earn"
          hasUnderline={false}
          textStyle="global/button-medium"
          rightIcon="chevron_right"
          testID="refer-and-earn-view"
        >
          {t("View")}
        </Link>
      </Stack>
    </Card>
  );
}

const styles = {
  card: css({
    boxSizing: "border-box",
    padding: "var(--space-5)",
    width: "100%",
  }),
};
